// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import report from './metaData/report'
export default {
  state: report,
  actions
}
